module.exports = __webpack_public_path__ + "5c114213/img/pdf-icon.79f04a36.svg";